/**
 * Terms of Service page for IdeaWeave.
 * Required for Google OAuth verification.
 */

import React from "react";

import { LegalPageLayout } from "./LegalPageLayout";

import "./LegalPage.scss";

export const TermsPage: React.FC = () => {
  return (
    <LegalPageLayout title="Terms of Service" backHref="/" dark={false}>
      <p className="legal-page__updated">Last updated: February 2025</p>

      <div className="legal-page__body">
        <p>
          By using IdeaWeave ("Service"), you agree to these Terms of Service
          ("Terms"). If you do not agree, please do not use the Service.
        </p>

        <h2>1. Description of Service</h2>
        <p>
          IdeaWeave is an AI-powered diagram creation tool that transforms text
          and voice into visual diagrams. The Service includes cloud storage to
          save and sync your diagrams across devices.
        </p>

        <h2>2. Account Responsibility</h2>
        <p>
          You may sign in using Google. You are responsible for maintaining the
          security of your account and for all activity that occurs under it.
          You must provide accurate information when creating your account.
        </p>

        <h2>3. Your Content</h2>
        <p>
          You retain full ownership of the diagrams and content you create on
          IdeaWeave. We do not claim any ownership over your work. By using the
          Service, you grant us a limited license to store, display, and process
          your content solely to provide and improve the Service.
        </p>

        <h2>4. Acceptable Use</h2>
        <p>You agree not to:</p>
        <ul>
          <li>
            Use the Service for any illegal purpose or in violation of any laws
          </li>
          <li>Infringe on the intellectual property or rights of others</li>
          <li>Upload malicious code, spam, or harmful content</li>
          <li>Attempt to bypass security measures or abuse the Service</li>
          <li>Use the Service to harass, harm, or defraud others</li>
        </ul>

        <h2>5. Disclaimer</h2>
        <p>
          The Service is provided "as is" without warranties of any kind. We do
          not guarantee that the Service will be uninterrupted, error-free, or
          free of harmful components. AI-generated content may be inaccurate or
          incomplete. You use the Service at your own risk.
        </p>

        <h2>6. Limitation of Liability</h2>
        <p>
          To the maximum extent permitted by law, we shall not be liable for any
          indirect, incidental, special, or consequential damages arising from
          your use of the Service.
        </p>

        <h2>7. Termination</h2>
        <p>
          We may suspend or terminate your access to the Service at any time for
          violation of these Terms or for any other reason. You may stop using
          the Service at any time.
        </p>

        <h2>8. Changes</h2>
        <p>
          We may update these Terms from time to time. We will notify you of
          material changes by updating the "Last updated" date. Your continued
          use of the Service after changes constitutes acceptance of the revised
          Terms.
        </p>

        <h2>9. Contact</h2>
        <p>
          For questions about these Terms, contact us at:{" "}
          <a href="mailto:wqxsam@outlook.com">wqxsam@outlook.com</a>
        </p>
      </div>
    </LegalPageLayout>
  );
};
